import { IFormattedGroup } from '../../store/modules/facility/i-facility';

export interface IBreadcrumbsRoute {
  breadcrumbName: string,
  path: string
}

export default (
  path: string,
  groups: IFormattedGroup,
  initialRouteName: string,
): IBreadcrumbsRoute[] => {
  const routes = path.split('/');
  const initialPath = routes.slice(1, 2)[0];
  const breadcrumbRoutes: IBreadcrumbsRoute[] = [{ breadcrumbName: initialRouteName, path: `/${initialPath}` }];

  if (!groups || !Object.values(groups).length) return breadcrumbRoutes;

  routes.slice(2).reduce(((acc, str) => {
    const routePath = `${acc}/${str}`;
    if (groups?.[str]?.name) {
      breadcrumbRoutes.push({ breadcrumbName: groups?.[str]?.name, path: routePath });
    }
    return routePath;
  }), `/${initialPath}`);
  return breadcrumbRoutes;
};
